import styled, { css } from "styled-components";

import { devices } from "src/styles";

interface Props {
  hasNote?: boolean;
}

export const ItemSelectionWrapper = styled.div`
  padding-bottom: 1rem;
`;

export const ItemSelectionRowWrapper = styled.div<Props>`
  border-bottom: 1px solid ${(props) => props.theme.gray};
  margin-bottom: 1rem;
  padding-bottom: 0.625rem;
  width: 100%;

  &:last-child {
    margin-bottom: 0;
  }

  & > div {
    :last-child {
      margin-top: 0.625rem;
    }
  }

  ${devices.tablet} {
    display: flex;
    align-items: center;
    justify-content: space-between;
  }

  ${(props) =>
    props.hasNote &&
    css`
      border-bottom: 0;
      margin-bottom: 0;
      padding-bottom: 0;
    `};
`;

export const DottedButtonWrapper = styled.button`
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100%;
  height: 2.5rem;
  background-color: transparent;
  border: 1.5px dashed ${(props) => props.theme.brandPrimary};
  border-radius: 0.25rem;
  cursor: pointer;
  transition: all 200ms;
`;

export const PickupScheduleLegendWrapper = styled.div`
  position: relative;
  margin-bottom: 1rem;
  border: 1px solid ${(props) => props.theme.gray};
  border-radius: 0.5rem;
  padding: 0.875rem 1.125rem;
`;

export const PickupScheduleLegendCollapseWrapper = styled.div`
  position: absolute;
  top: 0.5rem;
  right: 0.5rem;
  width: 1.5rem;
  height: 1.5rem;
  display: flex;
  align-items: center;
  justify-content: center;
`;

export const PickupScheduleSummaryWrapper = styled.div`
  text-align: left;
  width: 100%;
  max-width: 600px;
  margin: 0 auto;
  ${devices.desktop} {
    height: 96vh;
    overflow-y: auto;
    padding-right: 50px;
    padding-left: 50px;
    padding-bottom: 50px;
  }
`;

export const PickupScheduleSummaryCard = styled.div<{
  hasRightValues?: boolean;
  isCanceled?: boolean;
}>`
  background: #ffffff;
  box-shadow: 0px 1px 4px rgba(0, 0, 0, 0.15);
  padding: 0.625rem 0.875rem;
  border-bottom: 1px solid ${(props) => props.theme.gray};
  position: relative;
  min-height: 5rem;
  display: flex;
  align-items: center;

  ${(props) =>
    props.hasRightValues &&
    css`
      padding-right: 7rem;
    `}

  ${(props) =>
    props.isCanceled &&
    css`
      background-color: white;
      background-size: 10px 10px;
      background-image: repeating-linear-gradient(
        -45deg,
        rgba(247, 69, 69, 0.2) 0,
        rgba(247, 69, 69, 0.2) 1px,
        rgba(229, 229, 247, 0.2) 0,
        rgba(229, 229, 247, 0.2) 50%
      );
    `}

  &:last-of-type {
    border-end-end-radius: 0.5rem;
    border-end-start-radius: 0.5rem;
  }

  &:first-of-type {
    border-top-left-radius: 0.5rem;
    border-top-right-radius: 0.5rem;
  }
`;

export const PickupScheduleSummaryRightValue = styled.div<{
  hasCheckBox?: boolean;
}>`
  position: absolute;
  right: ${(props) => (props.hasCheckBox ? "3rem" : "0.875rem")};
  top: 1.5rem;
`;

export const PickupScheduleSummaryRightMiddleValue = styled.div`
  position: absolute;
  right: 0.875rem;
  top: 2.55rem;
`;
export const PickupScheduleSummaryRightBottomValue = styled.div`
  position: absolute;
  right: 0.875rem;
  top: 3rem;
`;

export const PickupScheduleSummaryLeftContent = styled.div<{
  isBig?: boolean;
  isBigger?: boolean;
  flexDirection?: string;
  hasPrice?: boolean;
}>`
  border-radius: 4px;
  box-shadow: rgba(9, 30, 66, 0.25) 0px 4px 8px -2px, rgba(9, 30, 66, 0.08) 0px 0px 0px 1px;
  background-color: ${(props) => props.theme.grayLighter};
  border: 1px solid ${(props) => props.theme.gray};
  display: flex;
  align-items: center;
  justify-content: center;
  width: 50px;
  height: 50px;
  overflow: hidden;

  ${(props) =>
    props.isBigger &&
    css`
      width: 70px;
      height: 70px;
      position: relative;

      span:first-child {
        margin-bottom: 0;
      }
    `};

  ${(props) =>
    props.hasPrice &&
    css`
      span:first-child {
        margin-bottom: 20px;
      }
    `};

  ${(props) =>
    props.isBig &&
    css`
      width: 100px;
      height: 100px;
    `};

  ${(props) =>
    props.flexDirection &&
    css`
      flex-direction: ${props.flexDirection};
    `};
`;

export const PickupScheduleSummaryContent = styled.div`
  margin-left: 0.875rem;
  display: flex;
  flex-direction: column;
  justify-content: center;
  flex: 1;
`;
